import React, { useState } from "react";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AuthPage } from "@/components/Auth";
import PricingEngine from "@/pages/PricingEngine";
import Dashboard from "@/pages/Dashboard";
import { Loader2 } from "lucide-react";
import { AmplifyLogo } from "@/components/AmplifyLogo";
import { Toaster } from "@/components/ui/toaster";

const AppContent = () => {
  const { isAuthenticated, loading } = useAuth();
  const [currentPage, setCurrentPage] = useState("engine"); // "engine" or "dashboard"
  const [loadQuoteId, setLoadQuoteId] = useState(null);
  const [triggerNewQuote, setTriggerNewQuote] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="text-center">
          <AmplifyLogo size={48} className="mx-auto mb-4" />
          <Loader2 className="animate-spin mx-auto text-[#3c68ff] mb-3" size={28} />
          <p className="text-sm text-slate-500 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <AuthPage />;
  }

  const handleNavigateToQuote = (quoteId) => {
    setLoadQuoteId(quoteId);
    setCurrentPage("engine");
  };

  const handleNewQuote = () => {
    setTriggerNewQuote(true);
    setLoadQuoteId(null);
    setCurrentPage("engine");
  };

  const handleNavigateToDashboard = () => {
    setCurrentPage("dashboard");
    setLoadQuoteId(null);
    setTriggerNewQuote(false);
  };

  if (currentPage === "dashboard") {
    return (
      <Dashboard 
        onNavigateToQuote={handleNavigateToQuote}
        onNewQuote={handleNewQuote}
        onBack={() => setCurrentPage("engine")}
      />
    );
  }

  return (
    <PricingEngine 
      onNavigateToDashboard={handleNavigateToDashboard}
      loadQuoteId={loadQuoteId}
      triggerNewQuote={triggerNewQuote}
      onQuoteLoaded={() => setLoadQuoteId(null)}
      onNewQuoteTriggered={() => setTriggerNewQuote(false)}
    />
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
      <Toaster />
    </AuthProvider>
  );
}

export default App;
